export const scheduledExecutionRead = (user, { organization, permissions }) => {
  return permissions.some(
    (permission) => permission.resource === "scheduled_execution" && permission.action === "read"
  );
};
export const scheduledExecutionWrite = (user, { organization, permissions }) => {
  return permissions.some(
    (permission) => permission.resource === "scheduled_execution" && permission.action === "write"
  );
};
